import { Injectable } from '@angular/core';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { UserService } from 'app/users/user.service';
import { SharedDataService } from './sharedData.service';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {
  
  groups: any;
  customerNumber: any;
  token: any;
  fullName: any;
  ssoId: any;
  email: any;

  constructor(
    private userService: UserService,
    private sharedService: SharedDataService
  ) {

      const queryString = window.location.search;
      if (queryString) {
        var urlParams = new URLSearchParams(queryString);
        this.groups = urlParams.get('groups');
        this.customerNumber = urlParams.get('customerNumber');
        this.token = urlParams.get('token');
        this.fullName = urlParams.get('fullName');
        this.ssoId = urlParams.get('ssoId');
        this.email = urlParams.get('email');
        
        this.userService.setProfile (this.buildUserProfile());
      }
   }

   buildUserProfile(): UserProfileRecord {
    return {
      groups: this.groups,
      customerNumber: this.customerNumber || "",
      fullName: this.fullName || "",
      ssoId: this.ssoId || "",
      email: this.email || ""
    }
  }

}
